import React from "react";
import { useLocation, navigate } from "@reach/router";
import { useAuth, AuthProvider } from "@src/contexts/AuthContext";
import Store from "@src/contexts/store";
import { Helmet } from 'react-helmet';
import AdminLayout from "./AdminLayout";
import UserLayout from "./UserLayout";
import DefaultLayout from "./DefaultLayout";
import AlertStack from '@components/AlertStack';
import InstallButton from "./InstallButton";

// Nested component to safely use the Auth context
const LayoutContent = ({ children }) => {
  const { pathname } = useLocation();
  const { userProfile, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin h-10 w-10 border-b-2 border-gray-500 rounded-full"></div>
      </div>
    )
  } ;

  const role = userProfile?.role;

  if (pathname.startsWith("/admin")) {
    if (role === "admin") return <AdminLayout>{children}</AdminLayout>;
    return null;
  }

  if (pathname.startsWith("/user")) {
    if (role === "user") return <UserLayout>{children}</UserLayout>;
    return null;
  }

  return <DefaultLayout>{children}</DefaultLayout>;
};

export default function BaseLayout({ children }) {
  return (
    <AuthProvider>
      <Store>
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <link
            key="apple-touch-icon"
            rel="apple-touch-icon"
            href="/icons/icon-192x192.png"
          />,
          <meta
            key="apple-mobile-web-app-capable"
            name="apple-mobile-web-app-capable"
            content="yes"
          />,
          <meta
            key="apple-mobile-web-app-status-bar-style"
            name="apple-mobile-web-app-status-bar-style"
            content="default"
          />,
          <meta
            key="apple-mobile-web-app-title"
            name="apple-mobile-web-app-title"
            content="AN-Phys"
          />
        </Helmet>
        <InstallButton />
        <AlertStack />
        <LayoutContent>{children}</LayoutContent>
      </Store>
    </AuthProvider>
  );
}
